// extracted by mini-css-extract-plugin
module.exports = {"codeWasSent":"SignInHeader_codeWasSent__1nKEp"};